import { useEffect, useState } from "react";
import { DEFAULT_TRANSLATION, TRANSLATION_CODES, isTranslationCode, type TranslationCode } from "@versedrill/core";
import { api } from "./api.ts";
import { useStore } from "./store.ts";

/**
 * The Bible versions this deployment can serve, and the one the player has chosen. Until the server answers (or if it
 * can't), only WEB is offered. If the saved choice isn't available any more, the player is moved back to WEB.
 */
export function useVersions(): { available: TranslationCode[]; current: TranslationCode; choose: (t: TranslationCode) => void } {
  const [available, setAvailable] = useState<TranslationCode[]>([DEFAULT_TRANSLATION]);
  const stored = useStore((s) => s.translation);
  const choose = useStore((s) => s.setTranslation);

  useEffect(() => {
    let cancelled = false;
    api
      .config()
      .then((cfg) => {
        if (cancelled) return;
        const offered = TRANSLATION_CODES.filter((c) => c === DEFAULT_TRANSLATION || cfg.translations?.includes(c));
        setAvailable(offered);
        if (!offered.includes(useStore.getState().translation)) useStore.getState().setTranslation(DEFAULT_TRANSLATION);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  return { available, current: isTranslationCode(stored) && available.includes(stored) ? stored : DEFAULT_TRANSLATION, choose };
}
